import { createAdminAsyncThunk } from '@/store/thunks/createAdminAsyncThunk';
import { TwoFactorMethod } from '@/types/authState.types';
import { VerificationDTO } from '@/types/dtos.types';

export const resend2faCodeThunk = createAdminAsyncThunk<
  VerificationDTO,
  { method: TwoFactorMethod },
  { rejectValue: { message: string } }
>(
  'auth/resend2faCode',
  async({ method }, { getState, extra: { authService }, rejectWithValue }) => {
    const state = getState();
    const twoFactorToken = state.auth.regToken;

    if (twoFactorToken === undefined) {
      return rejectWithValue({ message: 'Missing session token' });
    }

    try {
      return await authService.resendTwoFactorCode({ twoFactorToken, method });
    } catch (caught) {
      const message =
        caught instanceof Error ? caught.message : 'Failed to resend 2FA code';
      return rejectWithValue({ message });
    }
  }
);
